import Problem from "../../assets/images/Odoo/problem.png";
import Pattern from "../../assets/images/Odoo/pattern-30.png";
import 'odometer/themes/odometer-theme-default.css';
import React, { useEffect, useRef, useState } from "react";
import Odometer from "odometer";
import './about1.css';

export default function About1() {
    const counter1Ref = useRef(null);
    const counter2Ref = useRef(null);
    const sectionRef = useRef(null);
    const [started, setStarted] = useState(false);

     
    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting && !started) {
    //                     setStarted(true);

    //                      // Counter 1
    //                     const od1 = new Odometer({
    //                         el: counter1Ref.current,
    //                         value: 0,
    //                         duration: 2000,
    //                     });

    //                     // Counter 2
    //                     const od2 = new Odometer({
    //                         el: counter2Ref.current,
    //                         value: 0,
    //                         duration: 2000,
    //                     });

                        
    //                     setTimeout(() => {
    //                         od1.update(20);  
    //                         od2.update(50);  
    //                     }, 300);
    //                 }
    //             });
    //         },
    //         { threshold: 0.4 } 
    //     );

    //     if (sectionRef.current) {
    //         observer.observe(sectionRef.current);
    //     }

    //     return () => observer.disconnect();
    // }, [started]);

    return (
        <>
            <section className="problem-one" ref={sectionRef}>
                <div
                    className="problem-one_pattern-layer"
                    style={{ backgroundImage: `url(${Pattern})` }}
                />
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* Image Column */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <div className="image">
                                    <span className="icon">Since 2020 </span>
                                    <img src={Problem} alt="" />
                                </div>
                            </div>
                        </div>
                        {/* Content Column */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column">
                                {/* Sec Title Five */}
                                <div className="sec-title-five">
                                    {/* <div className="sec-title_title">About Odoo Erp!</div> */}
                                    <h2 className="sec-title_heading">
                                        What is Odoo ERP?
                                    </h2>
                                </div>
                                {/* <div className="bold-text">
                                    Excepteur sint occaecat cupidatat non proident, sunt in culpa
                                    officia deserunt mollit anim id est laborum.{" "}
                                </div> */}
                                <ul className="problem-one_list">
                                    <li>
                                        Odoo ERP is a powerful, all-in-one business management software designed to streamline operations, automate processes, and enhance productivity. It offers a suite of integrated applications covering essential business functions such as accounting, sales, inventory, HR, CRM, and more.
                                    </li>
                                    <li>
                                        Built for businesses of all sizes, Odoo ERP is highly customizable, scalable, and user-friendly, allowing organizations to adapt the system to their specific needs. Whether you're a small startup or an enterprise, Odoo simplifies complex workflows, improves collaboration, and helps you make data-driven decisions—all within a single, centralized platform.

                                    </li>
                                    <li>
                                        With its modular approach, businesses can implement only the features they need and expand as they grow, making Odoo an efficient and cost-effective ERP solution.
                                    </li>
                                </ul>
                                <div className="row clearfix">
                                    {/* Counter Column */}
                                    {/* <div className="problem-one_counter-column col-lg-6 col-md-6 col-sm-6">
                                        <div className="problem-one_counter-inner">
                                            <div className="problem-one_counter">
                                                <span className="odometer" ref={counter2Ref} />
                                                <sup>+</sup>
                                            </div>
                                            <div className="problem-one_counter_text">
                                                Wordwide Companies
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* Counter Column */}
                                    {/* <div className="problem-one_counter-column col-lg-6 col-md-6 col-sm-6">
                                        <div className="problem-one_counter-inner">
                                            <div className="problem-one_counter">
                                                <span className="odometer" ref={counter1Ref} />
                                                <sup>+</sup>
                                            </div>
                                            <div className="problem-one_counter_text">
                                                Business Employees
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div className="d-flex align-items-center">
                                    <div className="signature">Nilesh Sir</div>
                                    <h5>
                                        Nilesh sir <span>Managing Director</span>
                                    </h5>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}